import React, { useState, useEffect } from 'react';
import { getApiClient } from '../../api/apiClient';
import InvoiceStatistics from './InvoiceStatistics';
import InvoiceList from './InvoiceList';

const OutgoingInvoices = ({ onPreviewInvoice, formatCurrency, formatDate }) => {
  const [outgoingInvoices, setOutgoingInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOutgoingInvoices();
  }, []);

  const fetchOutgoingInvoices = async () => {
    try {
      setLoading(true);
      const client = getApiClient();
      const response = await client.get('/admin/outgoing');
      console.log('Fetched outgoing invoices:', response.data);
      const transformedInvoices = response.data.map(invoice => ({
        ...invoice,
        type: 'outgoing',
        seriesNumber: invoice.seriesNumber || invoice.invoiceNr,
        issueDate: invoice.issueDate || invoice.invoiceDate,
        clientName: invoice.buyerName || invoice.counterpartyName,
        buyerName: invoice.buyerName || invoice.counterpartyName,
        createdAt: invoice.issueDate || invoice.invoiceDate,
        status: invoice.status || 'SENT'
      }));

      setOutgoingInvoices(transformedInvoices);
    } catch (error) {
      console.error('Error fetching outgoing invoices:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshInvoices = () => {
    fetchOutgoingInvoices();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <>
      <InvoiceStatistics invoices={outgoingInvoices} formatCurrency={formatCurrency} />
      <InvoiceList 
        invoices={outgoingInvoices}
        formatCurrency={formatCurrency}
        formatDate={formatDate}
        onGenerateInvoice={() => {}} // Will be handled by parent
        invoiceType="outgoing"
        onPreviewInvoice={onPreviewInvoice}
        onRefresh={refreshInvoices}
      />
    </>
  );
};

export default OutgoingInvoices;
